import rangeSlider from "./rangeSlider";
import cookieInstance from './Cookie';
import { getCountryPrice } from "./countryPrice";
var Collections = function Collections() {
  var classes = {
    form: ".js-filter-form",
    resultsContainer: ".js-filter-results-container",
    productsContainer: ".js-filter-products-container"
  };
  var modifiers = {
    active: "active"
  };
  var elements = {
    form: null,
    resultsContainer: null,
    productsContainer: null
  };
  var init = function init() {
    queryElements();
    registerEvents();
    checkFilterAvailability();
  };
  var queryElements = function queryElements() {
    elements.productsContainer = document.querySelector(classes.productsContainer);
    elements.resultsContainer = document.querySelector(classes.resultsContainer);
    elements.form = document.querySelector(classes.form);
  };
  var registerEvents = function registerEvents() {
    if (elements.form) {
      elements.form.addEventListener("change", filterForm);
      elements.form.addEventListener("change", filterForm);
      rangeSlider(filterForm);
    }
  };
  var filterForm = function filterForm(e) {
    var data = new FormData(elements.form);
    var query = new URLSearchParams(data);
    var minPrice = query.get('min_price');
    var maxPrice = query.get('max_price');
    var changedMinPrice = getCountryPrice(minPrice);
    var changedMaxPrice = getCountryPrice(maxPrice);

    // console.log('minPrice', minPrice)
    // console.log('maxPrice', maxPrice)
    // console.log('changedMinPrice', changedMinPrice)
    // console.log('changedMaxPrice', changedMaxPrice)

    if (changedMinPrice) {
      query.set('min_price', changedMinPrice);
    }
    if (changedMaxPrice) {
      query.set('max_price', changedMaxPrice);
    }

    //console.log('queryString:', new URLSearchParams(data))

    var queryString = query.toString();
    makeRequest("?" + queryString).then(function () {
      //console.log("filtered");
    });
  };
  var makeRequest = function makeRequest(url) {
    return fetch(url, {
      method: "POST"
    }).then(function (response) {
      response.text().then(function (response) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(response, "text/html");
        elements.productsContainer.innerHTML = doc.querySelector(classes.productsContainer).innerHTML;
        elements.resultsContainer.innerHTML = doc.querySelector(classes.resultsContainer).innerHTML;
        window.history.pushState({}, "", url);
      });
      return response;
    });
  };
  var checkFilterAvailability = function checkFilterAvailability() {
    var countryPriceType = cookieInstance.getCookie('country_price_type');
    if (!countryPriceType) return;

    // disable filter if prices are fixed
    if ('fixed_price' === countryPriceType) {
      var _rangeSlider = document.querySelector('.range-slider');
      _rangeSlider.style.pointerEvents = 'none';
      _rangeSlider.style.cursor = 'not-allowed';
      _rangeSlider.style.opacity = 0.35;
    }
  };
  return init();
};
export default Collections;